const EVENT_URL = process.env.API_URL + '/event/';

const getPaginatedEvents = (context, page, filter, orderField, order, tags, unionTagFilter) => {
  return context.$http.get(EVENT_URL, {params: {page: page, filter: filter, orderField: orderField, order: order, tags: tags, unionTagFilter: unionTagFilter}});
};

const getEventsAfterDateTime = (context, tags, date) => {
  return context.$http.get(EVENT_URL + 'after-dateTime', {params: {tags: tags, date: date}});
};

export default {
  getPaginatedEvents,
  getEventsAfterDateTime
};



// WEBPACK FOOTER //
// ./src/api/event/eventHttp.js